import React, { useState } from "react";
import { Button, Form, Col } from "react-bootstrap";
import ERC20 from "../contracts/ERC20.json";
import Web3 from 'web3';

// Create a new proposal
// Lockbox instance (this.state.lockbox) is passed into to props as props.lockbox
// Address of sender (this.state.address) is passed into props as props.address
function CreateProposalTab(props) {

    // state to determine if proposal form is submittable
    const [submittable, setSubmittable] = useState(false);

    // proposal states
    const [whichProposal, setWhichProposal] = useState("");
    const [demProm, setDemProm] = useState("0");
    const [category, setCategory] = useState("");
    const [spend, setSpend] = useState("0");
    const [tokenType, setTokenType] = useState("0");
    const [additionalInfo, setAdditionalInfo] = useState("");
    const [receiver, setReceiver] = useState("");

    const handleProposal = (event) => {
        event.preventDefault();

        // changed to take in new tokenType value
        submitProposal(whichProposal, demProm, category, spend, tokenType, additionalInfo, receiver);
    }

    const submitProposal = async (isAdmin, demProm, category, amount, tokenType, additionalInfo, receiver) => {
        if (tokenType == 0 || tokenType == "0x0") {
            tokenType = '0x0000000000000000000000000000000000000000';
            amount = Web3.utils.toWei(amount, "ether")
        }
        else {
            // instance of erc20 contract for user to interact with
            const ERC20_instance = new window.web3.eth.Contract(ERC20.abi, tokenType);

            // dynamic conversion of amount based on erc20 token's decimal precision
            const ERC20_decimals = await ERC20_instance.methods.decimals().call();
            amount = (amount * (10 ** ERC20_decimals)).toString();
        }

        // query the current category balance for this proposal
        const temp = await props.lockbox.methods.categoryBalance(category, tokenType).call();

        // check and alert the user if category balance < requested proposal
        // but do not prevent the proposal from being created
        if (amount > temp) {
            alert("Please note that the " + category + " category contains less value than your proposed value. The proposal will still go through but could cause issues if additional deposits to this category aren't made before voting.");
        }

        try {
            await props.lockbox.methods.propose(isAdmin, demProm, amount, category, tokenType, additionalInfo, receiver).send({ from: props.address });
        } catch (error) {
            console.log(error)
        }
    }

    // function for changing proposal type
    const changeProposalType = (event) => {
        setWhichProposal(event.target.value);
        
        // make the proposal form submittable
        setSubmittable(true);
    }

    return (
        <>
            <form onSubmit={handleProposal}>
            <Form.Group as={Col} sm={10}>
                <h6 style={{textAlign: "left"}}>Type of Proposal</h6>
                <Form.Select name="proposalType" defaultValue="default" onChange={changeProposalType}>
                    <option value="default" disabled>Select a Proposal Type</option>
                    <option value="1">Admin</option>
                    <option value="2">Standard</option>
                    <option value="3" disabled>Whitelist</option>
                    <option value="4" disabled>Group Action</option>
                </Form.Select>
                {
                    whichProposal == "1" 
                    ?
                    <div>
                        <br />
                        <h6 style={{ textAlign: "left" }}>Promote or Demote?</h6>
                        <Form.Select name="demProm" defaultValue="0" onChange={(event) => {setDemProm(event.target.value)}}>
                            <option value="0" disabled>N/A</option>
                            <option value="1">Demote an admin</option>
                            <option value="2">Promote to admin</option>
                        </Form.Select>
                    </div> 
                    :
                    <div></div>
                }
                    <br />
                {
                    whichProposal == "2"
                    ?
                    <div>
                        <h6 style={{ textAlign: "left" }}>Category</h6>
                        <Form.Control type="text" name="category" placeholder="Category of Proposal" onChange={(event) => {setCategory(event.target.value)}}/>
                        <br />
                    </div>
                    :
                    <div></div>
                }
                {
                    whichProposal == "1" || whichProposal == "2"
                    ?
                    <div>
                        <h6 style={{ textAlign: "left" }}>Receiver</h6>
                        <Form.Control type="text" name="receiver" placeholder="Address of Receiver" onChange={(event) => {setReceiver(event.target.value)}}/>
                        <br />
                    </div>
                    :
                    <div></div>
                }
                {
                    whichProposal == "2" 
                    ?
                    <div>
                        <h6 style={{ textAlign: "left" }}>Amount</h6>
                        <Form.Control type="text" name="spend" placeholder="Amount of Proposal" onChange={(event) => {setSpend(event.target.value)}}/>
                        <br />

                        <h6 style={{ textAlign: "left" }}>Token Address</h6> {/* Input 0 for native token, otherwise ERC20 token address */}
                        <Form.Control type="text" name="tokenType" placeholder="Token Address" onChange={(event) => {setTokenType(event.target.value)}}/>
                        <br />
                    </div>
                    :
                    <div></div>
                }

                    <h6 style={{ textAlign: "left" }}>Additional Information</h6>
                    <Form.Control type="text" name="additionalInfo" placeholder="Additional Information" onChange={(event) => {setAdditionalInfo(event.target.value)}}/>
                    <br />
                
                <Button variant="dark" type="submit" disabled={ !submittable }>Submit New Proposal</Button> {/* Should be disabled until all the fields are filled */}
            </Form.Group>
            </form>
        </>
    )
}

export default CreateProposalTab;
